function readyToShip() {
  return {
    sizes: [],
    finishes: [],
    collections: [],
    showFilters: true,

    init() {
      this.initFiltersFromParams();
    },

    /**
     * Provide feedback to the user when adding to the cart
     */
    feedback(el) {
      const add = el.querySelectorAll(".ready-to-ship__card__cart--add");
      const added = el.querySelectorAll(".ready-to-ship__card__cart--added");
      add.forEach((element) => element.classList.add("hidden"));
      added.forEach((element) => element.classList.remove("hidden"));
      setTimeout(() => {
        add.forEach((element) => element.classList.remove("hidden"));
        added.forEach((element) => element.classList.add("hidden"));
      }, 1500);
    },

    /**
     * Function to add the desired quantity to the cart
     */
    addToCart(id, el) {
      const quantity = el.previousElementSibling.querySelector("input").value;
      const formData = {
        items: [
          {
            id,
            quantity,
          },
        ],
      };
      AM.addToCart(JSON.stringify(formData), this.feedback(el));
    },

    /**
     * Update the URL with filter params
     */
    updateUrlFromFilters() {
      const params = new URLSearchParams(window.location.search);
      if (this.sizes.length > 0) {
        params.set("size", `${this.sizes.join(",")}`);
      } else {
        params.delete("size");
      }
      if (this.finishes.length > 0) {
        params.set("finish", `${this.finishes.join(",")}`);
      } else {
        params.delete("finish");
      }
      if (this.collections.length > 0) {
        params.set("collection", `${this.collections.join(",")}`);
      } else {
        params.delete("collection");
      }
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    },

    /**
     * Set the filters from search params
     */
    initFiltersFromParams() {
      const params = new URLSearchParams(window.location.search);

      const getList = (key) => {
        const val = params.get(key);
        if (!val) return [];
        return val
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean);
      };

      this.sizes = getList("size");
      this.finishes = getList("finish");
      this.collections = getList("collection");

      if (this.sizes.length) {
        const sizesFilter = document.querySelector('[data-rts-filter="size"]');
        sizesFilter?.toggleAttribute("open");
      }

      if (this.finishes.length) {
        const finishesFilter = document.querySelector(
          '[data-rts-filter="finish"]'
        );
        finishesFilter?.toggleAttribute("open");
      }

      if (this.collections.length) {
        const collectionsFilter = document.querySelector(
          '[data-rts-filter="collection"]'
        );
        collectionsFilter?.toggleAttribute("open");
      }
    },
  };
}
